import { UploadOutlined } from '@ant-design/icons';
import type { RadioChangeEvent, UploadFile } from 'antd';
import { Col, DatePicker, Form, Input, Modal, Radio, Row, Select, Spin, TimePicker, Upload, message } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useFormContext } from '../../Context/DeclarationContext';
import { getCommunes, getRegions, getUrlFileBase64, uploadFiles } from '../../Services/declarations';
import RutTools from '../../helpers/format-rut';
import { FILE_UPLOAD_GENERAL_ERROR, FILE_UPLOAD_LARGE_ERROR, getBase64 } from '../../utils/generals';

type Props = {};

export const AccidentHistoryFormComponent = (props: Props) => {
  const { state, dispatch } = useFormContext();
  const [element_form] = Form.useForm();
  const [region, setRegion] = useState<any[]>([]);
  const [commune, setCommune] = useState<any[]>([]);
  const [optionHasPoliceReport, setOptionHasPoliceReport] = useState<boolean>(state?.hasAPoliceReport ? state?.hasAPoliceReport : false);
  const [optionCitation, setOptionCitation] = useState<boolean>(state?.policeReport?.hasACourtDate ? state?.policeReport?.hasACourtDate : false);
  const [optionInjuries, setOptionInjuries] = useState<boolean>(false);
  const [optionLicenseRetention, setOptionLicenseRetention] = useState<boolean>(false);
  const [optionAlcoholTest, setOptionAlcoholTest] = useState<boolean>(false);
  const [showUploadAlcoholTest, setShowUploadAlcoholTest] = useState<boolean>(
    state?.policeReport?.alcoholTestConducted ? state?.policeReport?.alcoholTestConducted : false
  );

  const [loadingfileAlcoholemia, setLoadingfileAlcoholemia] = useState(false);

  const [previewImage, setPreviewImage] = useState({
    previewOpen: false,
    title: '',
    url: '',
  });

  const [FileListAlcoholemia, setFileListAlcoholemia] = useState<any[]>(
    state.state_document?.find((doc) => doc.documentType === 'ALC') && state.state_document?.find((doc) => doc.documentType === 'ALC')?.filename
      ? [
          {
            uid: '-2',
            name: state.state_document?.find((doc) => doc.documentType === 'ALC')?.filename,
            status: 'done',
            url: state.state_document?.find((doc) => doc.documentType === 'ALC')?.url,
          },
        ]
      : []
  );

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_FORM_ELEMENT',
      payload: element_form,
    });
  }, [state.step]);

  const getCommunesByRegion = (id: string, preserveValue: string = '') => {
    getCommunes(id)
      .then((res) => {
        setCommune(res.data.communes);
      })
      .finally(() => {
        if (preserveValue.length > 0) {
          element_form.setFieldsValue({ communeId: preserveValue });
        } else {
          element_form.setFieldsValue({ communeId: undefined });
        }
      });
  };

  useEffect(() => {
    getRegions()
      .then((res) => {
        setRegion(res.data.regions);
      })
      .finally(() => {
        if (state?.state_form?.regionId) {
          element_form.setFieldsValue({
            regionId: state?.state_form?.regionId,
          });
          if (state.address?.communeId) {
            getCommunesByRegion(state?.state_form?.regionId, state.address?.communeId);
          } else {
            getCommunesByRegion(state?.state_form?.regionId);
          }
        }
      });

    element_form.setFieldsValue({
      claimDate: state.claimDate ?? null,
      claimTime: state.claimTime ? moment(state.claimTime, 'HH:mm:ss') : '',
      hasPoliceReport: state.hasAPoliceReport,
      alcoholTestConducted: state.policeReport?.alcoholTestConducted,
      InjuriesOcurred: state.policeReport?.InjuriesOcurred,
      licenseRetention: state.policeReport?.licenseRetention,
      policeStationReference: state.policeReport?.policeStationReference,
      declarationDate: state.policeReport?.declarationDate,
      policeReportNumber: state.policeReport?.policeReportNumber,
      hasACourtDate: state.policeReport?.hasACourtDate,
      name: state.policeReport?.judicialCourt?.name,
      citation_date: state.policeReport?.judicialCourt?.citation_date,
      streetAndNumber: state.address?.streetAndNumber,
      city: state.address?.city,
      hasAPoliceReport: state?.hasAPoliceReport,
    });
    setOptionHasPoliceReport(state?.hasAPoliceReport ? state?.hasAPoliceReport : false);
    setOptionCitation(state?.policeReport?.hasACourtDate ? state?.policeReport?.hasACourtDate : false);
    setShowUploadAlcoholTest(state?.policeReport?.alcoholTestConducted ? state?.policeReport?.alcoholTestConducted : false);
  }, []);

  const onFinish = (values: any) => {};

  const onFinishFailed = (errorInfo: any) => {};

  useEffect(() => {
    dispatch({
      type: 'SET_HEADER_TITLE',
      payload: 'Declaración de siniestros',
    });
  }, []);

  const onChangeValues = (changedValues: any, allValues: any) => {
    const {
      claimDate,
      claimTime,
      hasAPoliceReport,
      alcoholTestConducted,
      InjuriesOcurred,
      licenseRetention,
      policeStationReference,
      declarationDate,
      policeReportNumber,
      hasACourtDate,
      name,
      citation_date,
      streetAndNumber,
      city,
      communeId,
      regionId,
    } = allValues;

    const claimTimeConvert = claimTime ? moment(claimTime.$d).format('HH:mm:ss') : '';

    if (claimDate && citation_date) {
      const claim = claimDate.format('YYYY-MM-DD');
      const citacion = citation_date.format('YYYY-MM-DD');
      if (moment(citacion).isBefore(claim)) {
        element_form.setFields([
          {
            name: 'citation_date',
            errors: ['La fecha de citación no puede ser menor a la fecha del siniestro.'],
          },
        ]);
      } else {
        element_form.setFields([
          {
            name: 'citation_date',
            errors: [],
          },
        ]);
      }
    }

    dispatch({
      type: 'UPDATE_STATE_FORM',
      payload: {
        regionId,
      },
    });

    dispatch({
      type: 'UPDATE_POLICE_REPORT',
      payload: {
        claimDate,
        claimTime: claimTimeConvert,
        hasAPoliceReport,
        policeReport: {
          alcoholTestConducted,
          InjuriesOcurred,
          licenseRetention,
          policeStationReference,
          declarationDate,
          policeReportNumber,
          hasACourtDate,
          judicialCourt: {
            name,
            citation_date,
          },
        },
        address: {
          streetAndNumber,
          city,
          communeId,
        },
      },
    });
  };

  const onChangeHasPoliceReport = (e: RadioChangeEvent) => {
    setOptionHasPoliceReport(e.target.value);
  };

  const onChangeCitation = (e: RadioChangeEvent) => {
    setOptionCitation(e.target.value);
  };

  const onChangeInjuries = (e: RadioChangeEvent) => {
    setOptionInjuries(e.target.value);
  };

  const onChangeLicenseRetention = (e: RadioChangeEvent) => {
    setOptionLicenseRetention(e.target.value);
  };

  const onChangeAlcoholTest = (e: RadioChangeEvent) => {
    setOptionAlcoholTest(e.target.value);
    setShowUploadAlcoholTest(e.target.value);
  };

  const beforeUploadValidations = (info: UploadChangeParam<UploadFile<any>>): boolean => {
    const isJpgOrPng =
      info.file.type === 'image/jpg' || info.file.type === 'image/png' || info.file.type === 'image/jpeg' || info.file.type === 'application/pdf';
    if (!isJpgOrPng) {
      message.error('Solo puede subir archivos JPG, PNG, JPEG o PDF');
    }
    const size = info.file.size ?? 0;
    const isLt2M = size / 1024 / 1024 <= 10;
    if (!isLt2M) {
      message.error(FILE_UPLOAD_LARGE_ERROR);
    }
    return isJpgOrPng && isLt2M;
  };

  const onUploadAlcoholemia = async (info: UploadChangeParam<UploadFile<any>>) => {
    console.log('onUploadAlcoholemia file info: ', info);

    if (info.file.status === 'removed') {
      let documents = state?.state_document || [];
      const indexToDrop = documents.findIndex(({ documentType }) => documentType === 'ALC');
      if (indexToDrop !== -1) {
        documents[indexToDrop].filename = null;
        documents[indexToDrop].url = '';
        dispatch({
          type: 'UPDATE_STATE_DOCUMENT',
          payload: [...documents],
        });
        message.success('Documento eliminado correctamente');
        setFileListAlcoholemia([]);
      }
    }

    if (info.file !== undefined && info.file.status !== 'removed') {
      const beforeValidations = beforeUploadValidations(info);
      if (beforeValidations) {
        info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`;

        try {
          setLoadingfileAlcoholemia(true);
          const response = await uploadFiles(
            info.file.originFileObj,
            'ALC',
            `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`
          );
          let document = state?.state_document || [];
          info.file.status = 'done';
          const responseIndex = response?.data[0];
          const index = document.findIndex((doc) => doc.documentType === 'ALC');
          if (index !== -1) {
            document[index].filename = responseIndex?.filename;
            document[index].url = responseIndex?.url;
            document[index].isActive = true;

            setFileListAlcoholemia([
              {
                name: responseIndex?.filename,
                url: responseIndex?.url,
                isActive: true,
                status: 'done',
              },
            ]);
          }

          dispatch({
            type: 'UPDATE_STATE_DOCUMENT',
            payload: [...document],
          });

          message.success('Documento resultados de la alcoholemia subido correctamente');
        } catch (error) {
          const g = error as any;
          if (g?.status === 413) {
            message.error(FILE_UPLOAD_LARGE_ERROR);
          } else {
            message.error(FILE_UPLOAD_GENERAL_ERROR);
          }
        } finally {
          setLoadingfileAlcoholemia(false);
        }
      } else {
        setFileListAlcoholemia([]);
      }
    }
  };

  const handlePreviewFile = async (file: UploadFile) => {
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
    }

    if (file.name.toLocaleLowerCase().includes('.pdf')) {
      const response = await getUrlFileBase64(file.name);
      const byteCharacters = atob(response.data.buffer);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    } else {
      setPreviewImage({
        previewOpen: true,
        url: file.url || (file.preview as string),
        title: file.name,
      });
    }
  };

  return (
    <div style={{ marginTop: '24px' }} className="declarant_form">
      <div className="title">3. Antecedentes del siniestro</div>
      <div className="sub_title">Debe completar toda la información de manera obligatoria.</div>

      <Form onFinish={onFinish} onFinishFailed={onFinishFailed} colon={false} form={element_form} onValuesChange={onChangeValues} autoComplete="off">
        <Row
          style={{
            marginTop: '24px',
          }}
          gutter={[24, 24]}
        >
          <Col sm={8} xs={24}>
            <Form.Item
              label="Fecha del siniestro"
              name="claimDate"
              rules={[
                {
                  validator: (_, value) => {
                    if (value) {
                      const today = moment().format('YYYY-MM-DD');
                      const dateSelected = value.format('YYYY-MM-DD');
                      if (moment(dateSelected).isAfter(today)) {
                        return Promise.reject(new Error('Este campo no puede ser una fecha futura'));
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Este campo es requerido'));
                  },
                },
              ]}
            >
              <DatePicker
                format={'DD-MM-YYYY'}
                style={{
                  width: '100%',
                  height: '48px',
                }}
              />
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              label="Hora"
              name="claimTime"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <TimePicker
                format={'HH:mm:ss'}
                style={{
                  width: '100%',
                  height: '48px',
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Dirección del siniestro"
              name="streetAndNumber"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
                {
                  max: 100,
                  message: 'Debe tener máximo 100 caracteres',
                },
                {
                  pattern: /^[a-zA-Z0-9#&ñÑ ]+$/,
                  message: 'Solo se permiten letras (a-z, A-Z), números (0-9), y los caracteres # y &',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              label="Región"
              name="regionId"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <Select
                style={{
                  width: '100%',
                  height: '48px',
                }}
                showSearch
                filterOption={(input: string, option?: { label: string; value: string }) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                placeholder="Seleccione"
                onChange={(value) => {
                  getCommunesByRegion(value);
                }}
                options={region
                  ?.sort((a, b) => a?.regionName.localeCompare(b?.regionName))
                  .map((item) => ({
                    value: item.id,
                    label: item.regionName,
                  }))}
              ></Select>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              label="Comuna"
              name="communeId"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <Select
                style={{
                  width: '100%',
                  height: '48px',
                }}
                placeholder="Seleccione"
                showSearch
                filterOption={(input: string, option?: { label: string; value: string }) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={commune.map((item) => ({
                  value: item.id,
                  label: item.communeName,
                }))}
              ></Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Ciudad"
              name="city"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
                {
                  max: 20,
                  message: 'Debe tener máximo 20 caracteres',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item label="¿Este siniestro tiene parte o denuncia policial?" name="hasAPoliceReport">
              <Radio.Group onChange={onChangeHasPoliceReport} defaultValue={optionHasPoliceReport} value={optionHasPoliceReport}>
                <Radio value={true}>Si</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        {optionHasPoliceReport && (
          <>
            <Row gutter={[24, 24]}>
              <Col sm={8} xs={24}>
                <Form.Item label="¿Se realizó prueba de alcoholemia?" name="alcoholTestConducted">
                  <Radio.Group onChange={onChangeAlcoholTest} defaultValue={optionAlcoholTest}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              <Col sm={8} xs={24}>
                <Form.Item label="¿Hubo lesionados?" name="InjuriesOcurred">
                  <Radio.Group onChange={onChangeInjuries} defaultValue={optionInjuries}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              <Col sm={8} xs={24}>
                <Form.Item label="¿Retención de la licencia?" name="licenseRetention">
                  <Radio.Group onChange={onChangeLicenseRetention} defaultValue={optionLicenseRetention}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            {showUploadAlcoholTest ? (
              <Row gutter={[24, 24]}>
                <Col sm={8} xs={24}>
                  <Form.Item label="Resultados de la alcoholemia">
                    <Spin spinning={loadingfileAlcoholemia} size="small">
                      <Upload
                        name="avatar"
                        defaultFileList={FileListAlcoholemia.length ? [...FileListAlcoholemia] : []}
                        fileList={FileListAlcoholemia?.length ? [...FileListAlcoholemia] : []}
                        listType="picture"
                        maxCount={1}
                        onChange={onUploadAlcoholemia}
                        onPreview={handlePreviewFile}
                      >
                        <div className="upload_file">
                          <UploadOutlined /> Subir archivo
                        </div>
                        <small className="text_small">Archivos JPG, PNG, JPEG, PDF - Tamaño máximo 10MB.</small>
                      </Upload>
                    </Spin>
                  </Form.Item>
                </Col>
              </Row>
            ) : null}

            <Row gutter={[24, 24]}>
              <Col sm={8} xs={24}>
                <Form.Item
                  label="Declarar la unidad policial del parte"
                  name="policeStationReference"
                  rules={[
                    {
                      required: true,
                      message: 'Este campo es requerido',
                    },
                    {
                      max: 120,
                      message: 'Debe tener máximo 120 caracteres',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col sm={8} xs={24}>
                <Form.Item
                  label="Ingresar fecha del parte"
                  name="declarationDate"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value) {
                          const claimDate = element_form.getFieldValue('claimDate');
                          if (claimDate) {
                            const start = claimDate.format('YYYY-MM-DD');
                            const end = value.format('YYYY-MM-DD');
                            if (moment(end).isBefore(start)) {
                              return Promise.reject(new Error('La fecha del parte no puede ser menor a la fecha del siniestro.'));
                            }
                            if (value.isAfter(moment(), 'day')) {
                              return Promise.reject(new Error('La fecha del parte no puede ser después de hoy.'));
                            }
                          }
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Este campo es requerido'));
                      },
                    },
                    {
                      required: true,
                      message: 'Este campo es requerido',
                    },
                  ]}
                >
                  <DatePicker
                    format={'DD-MM-YYYY'}
                    style={{
                      width: '100%',
                      height: '48px',
                    }}
                  />
                </Form.Item>
              </Col>

              <Col sm={8} xs={24}>
                <Form.Item
                  label="Declarar número de parte policial"
                  name="policeReportNumber"
                  rules={[
                    {
                      required: true,
                      message: 'Este campo es requerido',
                    },
                    {
                      max: 120,
                      message: 'Debe tener máximo 120 caracteres',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[24, 24]}>
              <Col sm={8} xs={24}>
                <Form.Item label="¿Citación al juzgado?" name="hasACourtDate">
                  <Radio.Group onChange={onChangeCitation} defaultValue={optionCitation}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>

              {optionCitation && (
                <>
                  {' '}
                  <Col sm={8} xs={24}>
                    <Form.Item
                      label="Nombre del juzgado"
                      name="name"
                      rules={[
                        {
                          required: true,
                          message: 'Este campo es requerido',
                        },
                        {
                          max: 50,
                          message: 'Debe tener máximo 50 caracteres',
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={8} xs={24}>
                    <Form.Item
                      label="Fecha de citación"
                      name="citation_date"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: 'Este campo es requerido',
                      //   },
                      // ]}
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value) {
                              const claimDate = element_form.getFieldValue('claimDate');
                              if (claimDate) {
                                const start = claimDate.format('YYYY-MM-DD');
                                const end = value.format('YYYY-MM-DD');
                                if (moment(end).isBefore(start)) {
                                  return Promise.reject(new Error('La fecha de citación no puede ser menor a la fecha del siniestro.'));
                                }
                              }
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error('Este campo es requerido'));
                          },
                        },
                      ]}
                    >
                      <DatePicker
                        format={'DD-MM-YYYY'}
                        style={{
                          width: '100%',
                          height: '48px',
                        }}
                      />
                    </Form.Item>
                  </Col>{' '}
                </>
              )}
            </Row>
          </>
        )}
      </Form>
      <Modal
        open={previewImage.previewOpen}
        title={previewImage.title}
        footer={null}
        onCancel={() => setPreviewImage({ ...previewImage, previewOpen: false })}
        width={1000}
      >
        <img alt="preview" style={{ width: '100%' }} src={previewImage.url} />
      </Modal>
    </div>
  );
};
